import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import questionsTemplates from 'modules/surveys/store/collections/questionsTemplates'

interface Props {
  onCancel: () => void
  onClose: () => void
  questionsTemplateId: string
  navigatePathOnDeleted: string
}

const TemplateDeleteModal = ({
  questionsTemplateId,
  onClose,
  onCancel,
  navigatePathOnDeleted,
}: Props) => {
  const navigate = useNavigate()

  const onSubmit = async (closePortal: ClosePortalFn) => {
    const questionsTemplate = questionsTemplates.find({
      id: questionsTemplateId,
    })

    if (!questionsTemplate) return

    const { success } = await asyncAction(() => questionsTemplate.destroy())

    if (success) {
      closePortal()
      navigate(navigatePathOnDeleted)
    }
  }

  return (
    <Modal
      description={i18n.t('app_store_v2.apps.performance_v2.settings.templates.delete.description')}
      footer={
        <>
          <Button type="secondary" onClick={onCancel}>
            {i18n.t('common.cancel')}
          </Button>
          <Button type="negative" submit>
            {i18n.t('app_store_v2.apps.performance_v2.settings.templates.delete.submit')}
          </Button>
        </>
      }
      illustration="delete"
      onClose={onClose}
      onSubmit={onSubmit}
      title={i18n.t('app_store_v2.apps.performance_v2.settings.templates.delete.title')}
    ></Modal>
  )
}

export default observer(TemplateDeleteModal)
